import { render, staticRenderFns } from "./PurchaseNew.vue?vue&type=template&id=74aa9f4c&scoped=true"
import script from "./PurchaseNew.vue?vue&type=script&lang=js"
export * from "./PurchaseNew.vue?vue&type=script&lang=js"
import style0 from "./PurchaseNew.vue?vue&type=style&index=0&id=74aa9f4c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74aa9f4c",
  null
  
)

export default component.exports